import {first, find, omitBy, isEmpty, isNil, map,sortBy} from 'lodash';
import normalizer from '..';

const response = (data: any, voucherList: any) => {
  data = normalizer.response.inventoryTranslation(data);

  const productComponent = omitBy({
    // ...data.product,
    productName : data.product.name,
    productCode : data.product.code,
    productType : data.product.type,
    productAlias : data.product.alias,
    baseUOM : data.product.baseUOM,
    stockUOMs : data.product.stockUOMs,
    description : data.product.description,
    images : data.product.images,
    featuredImage : find(data.product.images, image => { return image.feature == true }),
    existing : true
  },isNil)

  const getPricingSchemaByID = (pricingID,pricingSchemaList) =>{

    let pricingObj = find(pricingSchemaList,pricing => {
      return pricing._id == pricingID;
    })

    return pricingObj;
  }
  const PricingList = map(data.pricing,(pricingObj,index) => {
    return omitBy({
      pricingScheme: pricingObj.pricingID,
      selectedPricingSchema: getPricingSchemaByID(pricingObj.pricingID,data.pricing_data),
      salesUOM: pricingObj.salesUOM,
      currency: pricingObj.currency,
      salesPrice: pricingObj.value,
      existing : true,
      key : index
    },isNil)
  })

  const stockUOMs = map(productComponent?.stockUOMs,stockObj => {
    return omitBy({
      ...stockObj,
      existing : true
    },isNil)
  })

  const imageList =  map(sortBy(data.product.images,'feature'),(imageObj,i) => {
    let imgData = {
      fileID : i,
      image: imageObj.file_data?.file_url,
      feature: imageObj.feature,
      selected: imageObj.feature,
      variantCode:imageObj?.variantCode
    }
    return imgData;
  })

  const stockVariants = map(data.ecomData?.stockVariants,variantObj=>{
    variantObj.stockLimit = variantObj.stockLimit || 0;
    return variantObj
  })

  return omitBy({
    ...data.ecomData,
    stockVariants: stockVariants,
    inventoryID: data._id,
    product : productComponent,
    isPharmaProduct:data.ecomData.isPharmaProduct,
    pharmaProductClause: data.displayPharmaClause,
    orgData : data.org_data,
    orgID : data.orgID,
    productImages: imageList,
    disablePurchase: data.disablePurchase || false,
    featuredImage : find(imageList, image => { return image.feature == true }),
    categories: !isEmpty(data.product?.categories) ? data.product.categories : data.ecomData.categories,
    voucherList
    /*baseUOM : productComponent?.baseUOM?.uom,
    stockUOMs : stockUOMs || [],
    pricing: PricingList || []*/
  }, isNil)
}

export default response;
